import { useCallback, useState } from "react";
import { Button, LoadingIndicator, ModalV2, Text } from "@jsq/ds/core";

export type ExportButtonProps = {
  onExport: () => Promise<void>;
  disabled?: boolean;
  testId: string;
};

export const ExportButton = ({ onExport, disabled = false, testId }: ExportButtonProps) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExportClick = useCallback(async () => {
    if (disabled) return;
    setIsExporting(true);
    try {
      await onExport();
    } catch {
      // Silently fail for user experience
    } finally {
      setIsExporting(false);
    }
  }, [disabled, onExport]);

  return (
    <>
      <Button
        variant="primary"
        icon="download"
        onClick={handleExportClick}
        disabled={disabled || isExporting}
        data-testid={testId}
      >
        Export
      </Button>

      <ModalV2
        show={isExporting}
        closeOnClickOutside={false}
        backdrop={true}
        title="Exporting data"
      >
        <ModalV2.Body>
          <Text align="left" marginBottom="md">
            Preparing your export. This may take a moment.
          </Text>
          <LoadingIndicator variant="primary" />
        </ModalV2.Body>
      </ModalV2>
    </>
  );
};
